import IndicatorsLegal from "./Indicators.vue"
export default IndicatorsLegal